import { render } from "./Child-List-Select.vue?vue&type=template&id=34b79a96"
import script from "./Child-List-Select.vue?vue&type=script&lang=js"
export * from "./Child-List-Select.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__